/**
 * Die Wahl des Erscheinungsbilds — Automatik, Hell, Dunkel (HM-107, ADR 0030).
 *
 * **Sie steht im Kontomenü**, nicht in der Kopfzeile: Sie gehört weder der
 * Anlage noch einer Ansicht, sondern dem, der vor dem Bildschirm sitzt — wie
 * das Profil. In der Kopfzeile stünde sie neben dem Zeitraum, mit dem sie
 * nichts zu tun hat, und auf jeder Seite noch einmal.
 *
 * **Drei Wahlen, als Radiogruppe.** Das Kit hat einen Knopf mit zwei Zuständen,
 * weil es beide Fassungen zeigen soll; die Anwendung soll dem System folgen
 * können, und dafür braucht die Automatik einen sichtbaren Platz — sonst wüsste
 * niemand, ob „Hell" gewählt ist oder nur gerade gilt. `SegmentedControl` ist
 * die Komponente für wenige gleichrangige Möglichkeiten; die Symbole daneben
 * sagen, was jede Wahl zeichnet.
 */
import { SegmentedControl } from "@hausmeter/ui";
import { useTheme, type ThemePreference } from "../lib/theme.js";
import { trackUiAction } from "../lib/usage.js";

const OPTIONS: readonly { value: ThemePreference; label: string }[] = [
  { value: "system", label: "Automatik" },
  { value: "light", label: "Hell" },
  { value: "dark", label: "Dunkel" },
];

export function AppearancePicker() {
  const { preference, setPreference } = useTheme();

  return (
    <SegmentedControl
      label="Erscheinungsbild"
      size="sm"
      fill
      options={OPTIONS}
      value={preference}
      onChange={(next) => {
        setPreference(next);
        trackUiAction("theme.change");
      }}
    />
  );
}
